/** A project's scripts — the list a PM starts from. */

import { Link } from "react-router-dom";

import { endpoints } from "@/api/endpoints";
import { useProject } from "@/components/ProjectLayout";
import { Badge, Empty, ErrorState, Loading, RelativeTime } from "@/components/ui";
import { useAsync } from "@/hooks/useAsync";

export function Scripts() {
  const { project, can } = useProject();
  const { data, error, loading, reload } = useAsync(
    () => endpoints.scripts(project.slug),
    [project.slug],
  );

  if (loading) return <Loading rows={4} label="Loading scripts" />;
  if (error) return <ErrorState error={error} onRetry={reload} />;

  const scripts = data?.items ?? [];

  if (scripts.length === 0) {
    return (
      <div className="card">
        <Empty
          title="No scripts yet"
          action={
            can("engineer") ? (
              <Link to="repositories" className="button button--primary">
                Add a script
              </Link>
            ) : undefined
          }
        >
          Upload a script as a ZIP, or connect a repository with a delivery manifest.
        </Empty>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="table__scroll">
        <table className="table">
          <thead>
            <tr>
              <th>Script</th>
              <th>Entrypoint</th>
              <th>Branch</th>
              <th>Maintainers</th>
              <th>Added</th>
            </tr>
          </thead>
          <tbody>
            {scripts.map((script) => (
              <tr key={script.id}>
                <td>
                  <Link to={`scripts/${script.name}`} style={{ fontWeight: 550 }}>
                    {script.name}
                  </Link>
                  {script.description && (
                    <div className="muted truncate" style={{ maxWidth: 380, fontSize: 12.5 }}>
                      {script.description}
                    </div>
                  )}
                </td>
                <td className="mono muted">{script.entrypoint_path}</td>
                <td className="muted">
                  {script.branch ? (
                    <span className="mono">branch {script.branch}</span>
                  ) : (
                    <Badge>Uploaded</Badge>
                  )}
                </td>
                <td className="muted" style={{ fontSize: 12.5 }}>
                  {script.maintainer_emails.length > 0
                    ? script.maintainer_emails.join(", ")
                    : "—"}
                </td>
                <td className="muted">
                  <RelativeTime iso={script.created_at} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
